export const SESSION_RESUME_PUBLISHED_EVENT = 'ofertator:session-resume-published'

export function notifySessionResumePublished(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(SESSION_RESUME_PUBLISHED_EVENT))
}

export function subscribeSessionResumePublished(callback: () => void): () => void {
  if (typeof window === 'undefined') {
    return () => {}
  }
  window.addEventListener(SESSION_RESUME_PUBLISHED_EVENT, callback)
  return () => {
    window.removeEventListener(SESSION_RESUME_PUBLISHED_EVENT, callback)
  }
}
